import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";
import { puedeVerUtilidadTiendas } from "../Reportes/usuariosUtilidadTiendas";

function BotonesTiendas() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Operación", items: [
      { label: "Venta", icon: "fas fa-receipt", color: "#10b981", href: "/VentasTiendasCreate", desc: "Nueva venta", enabled: !!user.ventasTiendas },
      { label: "Corte Diario", icon: "fas fa-money-check-alt", color: "#f59e0b", href: "/CorteTiendas", desc: "Corte de caja", enabled: !!user.corteTiendas },
      { label: "Abonos", icon: "fas fa-donate", color: "#3b82f6", href: "/ListadoAbonosTiendas", desc: "Pagos recibidos", enabled: !!user.abonosTiendas },
      { label: "Devoluciones", icon: "fas fa-undo", color: "#ef4444", href: "/ListadoDevolucionesTiendas", desc: "Devoluciones", enabled: !!user.devolucionesTiendas },
      { label: "Reporte de Ventas", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/ListadoVentasTiendas", desc: "Ventas de tienda", enabled: !!user.listadoVentasTiendas },
      { label: "Utilidad Tiendas", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ReporteUtilidadesTiendas", desc: "Utilidad de ventas de tienda", enabled: puedeVerUtilidadTiendas(user) },
    ]},
    { section: "Inventario", items: [
      { label: "Inventario", icon: "fas fa-warehouse", color: "#06b6d4", href: "/ListadoInventariosTiendas", desc: "Existencias de tienda", enabled: !!user.inventariosTiendas },
      { label: "Inventario General", icon: "fas fa-warehouse", color: "#06b6d4", href: "/ListadoInventarios", desc: "Todas las areas", enabled: !!user.inventariosTiendas },
      { label: "Kardex", icon: "fas fa-clipboard-list", color: "#14b8a6", href: "/ListadoKardex", desc: "Movimientos por modelo", enabled: !!user.inventariosTiendas },
      { label: "Ajuste Inventario", icon: "fas fa-plus", color: "#8b5cf6", href: "/ListadoAjustesInventario", desc: "Ajustes de existencia", enabled: !!user.ajustesInventario },
      { label: "Disponible", icon: "fas fa-list-alt", color: "#64748b", href: "/ListadoDisponibleVendedor", desc: "Disponible para venta", enabled: !!user.disponible_vendedores },
    ]},
    { section: "Traspasos", items: [
      { label: "Solicitud Traspaso", icon: "fas fa-file-export", color: "#f59e0b", href: "/ListadoTraspasosSolicitud", desc: "Solicitar mercancia", enabled: !!user.menu_traspasos_salida },
      { label: "Traspasos Salida", icon: "fas fa-sign-out-alt", color: "#ef4444", href: "/ListadoTraspasosSalida", desc: "Salidas de tienda", enabled: !!user.menu_traspasos_salida },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt", color: "#10b981", href: "/ListadoTraspasosEntrada", desc: "Entradas a tienda", enabled: !!user.menu_traspasos_entrada },
      { label: "Traspaso Dinero", icon: "fas fa-dollar-sign", color: "#3b82f6", href: "/TraspasosDineroCreate", desc: "Movimiento de efectivo", enabled: !!user.gastosTiendas },
    ]},
    { section: "Gastos y Clientes", items: [
      { label: "Gastos", icon: "fas fa-clipboard-list", color: "#ef4444", href: "/GastosTiendas", desc: "Gastos de tienda", enabled: !!user.gastosTiendas },
      { label: "Conceptos Gastos", icon: "fas fa-tags", color: "#64748b", href: "/ListadoConceptosGastosTiendas", desc: "Catalogo de conceptos", enabled: !!user.gastosTiendas },
      { label: "Clientes", icon: "fas fa-user-tie", color: "#64748b", href: "/ClientesTiendas", desc: "Clientes de tienda", enabled: !!user.menu_clientes },
      { label: "Estado de Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/EstadoCuentaTiendas", desc: "Saldos de clientes", enabled: !!user.menu_clientes },
      { label: "Ultimo Precio", icon: "fas fa-dollar-sign", color: "#8b5cf6", href: "/ReporteUltimoPrecio", desc: "Precio por cliente", enabled: !!user.ventasTiendas },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Tiendas"
      descripcion="Punto de venta, inventario y cortes"
      icono="fas fa-store-alt"
      color="#10b981"
      secciones={SECCIONES}
    />
  );
}

export default BotonesTiendas;
